<form [formGroup]="VisitorPhoneForm" *ngIf="IsInitialised">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <h5>Country*</h5>
        <select (change)="OnSelectCountry($event)" formControlName="CountryID" class="form-control">
          <option *ngFor="let i of CountryList" [value]="i.DataValue">{{i.DataText}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <h5>Mobile*</h5>
        <!--<span>{{VisitorPhoneForm.value.CountryCode}}</span>-->
        <input type="text" formControlName="MobileNumber" autocomplete="off" (keypress)="manikInteger($event)" (keyup)="CheckIfContactExists()"
               [maxlength]="maxlength" class="form-control">
        <span *ngIf="VisitorPhoneForm.controls.MobileNumber.dirty && VisitorPhoneForm.controls.MobileNumber.errors" class="text-danger">
          <span *ngIf="VisitorPhoneForm.controls.MobileNumber.errors.required">required</span>
          <span *ngIf="VisitorPhoneForm.controls.MobileNumber.errors.maxlength">
            Please enter a number with {{maxlength}}
            digits
          </span>
        </span>
      </div>
    </div>
  </div>
</form>
<manik-data-loader *ngIf="ShowLoader"></manik-data-loader>
<form [formGroup]="VisitorDetailsForm" *ngIf="ShowForm" #visitorForm="ngForm">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <h5>Name</h5>
        <input type="text" class="form-control" placeholder="Enter your name" formControlName="VisitorName" />
        <span *ngIf="visitorForm.submitted && dForm.VisitorName.errors" class="text-danger">
          <span *ngIf="dForm.VisitorName.errors.required"> {{EmailError}}</span>
          
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <h5>Email</h5>
        <input type="text" class="form-control" formControlName="EmailID" placeholder="Enter your email address" />
        <span *ngIf="visitorForm.submitted && dForm.EmailID.errors" class="text-danger">
          <span *ngIf="dForm.EmailID.errors.required"> {{EmailError}}</span>
          <span *ngIf="dForm.EmailID.errors.email"> Invalid email</span>
        </span>
        <span *ngIf="showEmailError" class="text-danger">
          {{ EmailError}}
        </span>
      </div>
    </div>
   
  </div>
  <!-- <div class="row">
    <div class="col-md-6" *ngIf="AskEmail">
      <div class="form-group">
        <h5>Password</h5>
        <input type="password" class="form-control" formControlName="Password" placeholder="Enter your password" />
        <span *ngIf="showPassError" class="text-danger">
          {{ PassError}}
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group IauthorizeCheckBox">
        <h5>  
          <span *ngIf="false">OTP Verification</span>
        </h5>
        <div class="cManikCheckBox"><input type="checkbox" class="form-control" [(ngModel)]="ShowVerifyOTP" (click)="ShowVerifyOTP=!ShowVerifyOTP"></div><span>Verify Using OTP</span>
      </div>
    </div>

  </div> -->
  <div class="row">
    <div class="col-md-12">
      <app-otp-handler *ngIf="ShowVerifyOTP" [OTPHandle]="OTPHandle" (OTPVerified)="OTPVerified()"></app-otp-handler>
    </div>
   
  </div>
  

  <div class="row" *ngIf="AskEmail">
    <div class="col-md-12">
      <div class="form-group IauthorizeCheckBox">
        <div class="cManikCheckBox"><input type="checkbox" class="form-control" formControlName="OKToContactBack"></div><span>I authorize {{PortalName}} to contact me with the details provided</span>
      </div>
    </div>
  </div>
 
  
  <button class="cPortalSubmit" (click)="SubmitForm()" *ngIf="!submitted && AskEmail">Submit</button>
  <button class="btn btn-primary" *ngIf="submitted">
    <manik-button-loader></manik-button-loader>
  </button>
</form>



